import { Modal } from "components/designV2/modal/modal";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  titleKey?: string;
  messageKey: string;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  isOpen,
  onClose,
  titleKey = "Alerts.OhNo",
  messageKey,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      label={t(titleKey)}
      isOpen={isOpen}
      onClose={onClose}
      size="compact"
      showCloseButton={false}
      contentOverflow="visible"
      centerText
      footer={
        <PrimaryButton label={t("General.Ok")} onClick={onClose} />
      }
    >
      <Message>{t(messageKey)}</Message>
    </Modal>
  );
};

const Message = styled.p`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue2};
  margin: 0;
  text-align: center;
  width: 100%;
`;
